<div class="container pt-5">
    <div class="row">
        <div class="col-md-7">
            <div class="input-group">
                <input type="text" [formControl]="searchInputCtrl"
                    class="form-control">
                <span class="icon-addon">
                    <i class="far fa-times" [hidden]="!searchInputCtrl.value"
                        (click)="clear_search()"></i>
                    <i class="far fa-search"
                        [hidden]="searchInputCtrl.value"></i>
                </span>
            </div>
        </div>

        @if (searchResultNumber > 0) {
        <p class="col-md-4 appErrorNumber">{{ searchResultNumber }} error@if
            (searchResultNumber > 1) {
            <span>s</span>
            } found</p>
        }
    </div>

    <br>

    <table class="table table-hover">

        <thead>
            <tr>
                <th scope="col">Received_at</th>
                <th scope="col">IP</th>
                <th scope="col">Source</th>
                <th scope="col">Hostname</th>
                <th scope="col">Program</th>
                <th scope="col">Message</th>
                <th scope="col">Actions</th>
            </tr>
        </thead>

        @if (filteredErrors$ | async; as errors) {

        @for (error of errors; track error) {
        <tbody>
            <tr>
                <td>{{ error.received_at | date : 'medium' }}</td>
                <td>{{ error.source_ip }}</td>
                <td>{{ error.source_name }}</td>
                <td>{{ error.hostname }}</td>
                <td>{{ error.program }}</td>
                <td
                    [innerHTML]="error.message | backoffice_search | linky : { newWindow: true }"></td>
                <td>
                    <div class="btn-group" style="display: flex;">
                        <button class="btn btn-primary"
                            title="view in papertrail">
                            <a
                                href="https://my.na-01.cloud.solarwinds.com/219683007912809472/logs?focus={{ error.id }}&amp;selected={{ error.id }}"
                                target="_blank">
                                <i class="far fa-search"
                                    style="color: white"></i>
                            </a>
                        </button>
                        <button class="btn btn-danger" title="delete this error"
                            (click)="delete(error.id)">
                            <i class="fa fa-trash-alt"></i>
                        </button>
                    </div>
                </td>
            </tr>
        </tbody>
        }

        <div class="text-center">
            <button class="btn btn-danger" (click)="deleteAll(errors)">
                Delete all errors
            </button>
        </div>

        }
    </table>

    <br>

</div>